export default "__VITE_ASSET__C6U_LMYa__"